<template>
    <el-dialog v-model="dialogUpload" :close-on-click-modal="false" class="form-dialog" width="400px">
        <el-upload
            class="upload-demo"
            drag
            :action="upUrl"
            multiple
            :headers="datas.header"
            :data="datas.parames"
            :on-success="upSuccess"
            :on-error="upError"
            :show-file-list="false"
        >

            <ui-icon type="yunshangchuan" size="130" />
            <div class="el-upload__text">
                可以拖动文件到此区域完成上传 <em>点击上传</em>
            </div>
        </el-upload>
    </el-dialog>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive, inject, watch } from 'vue'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import Api from '@/config/api'
    export default defineComponent({
        components: {
        },
        props: {
            cid: {
                type: String,
                default: ''
            },
            dir: {
                type: String,
                default: 'images'
            },
            isAuth: {
                type: Boolean,
                default: false
            },
            module: {
                type: String,
                default: ''
            }
        },
        setup(props, context) {
            const upUrl = Api.AdminAttachmentUpload
            const { proxy } = getCurrentInstance()
            const dialogUpload = inject('dialogUpload')
            const formTitle = ref()
            const datas = ref()
            let params = {
                dir: props.dir,
                module: props.module || 'admin',
                cid: props.cid,
                is_auth: props.isAuth ? 1 : 0
            }
            datas.value = proxy.jiu.UpdateParams(params)
            watch(
                () => props.cid,
                (newv, oldv) => {
                    params.cid = newv
                    datas.value = proxy.jiu.UpdateParams(params)
                }
            )

            const upSuccess = (response, file, fileList) => {
                context.emit('update:getDataList')
                dialogUpload.value = false
                if (response.message === 'success') {
                    proxy.jiu.toast('服务器中已经存在，请在列表中查找')
                    return true
                }
                proxy.jiu.toast('上传成功')
            }
            const upError = (error, file, fileList) => {
                let jsonObj = JSON.parse(error.message)
                proxy.jiu.showError(jsonObj)
            }
            return {
                upUrl,
                formTitle,
                dialogUpload,

                upSuccess,
                upError,
                datas
            }
        }
    })
</script>

<style scoped>

</style>
